module.exports = __webpack_public_path__ + "img/Edit.f106c169.svg";